
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $a0ded8d40eb357b6$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"ksAJF\",\"index.81bdb204.js\",\"84OxV\",\"math.33efa2c8.glb\",\"2gvxf\",\"jennings_lo.b0822633.glb\",\"iJUqe\",\"questionmark.638412b5.glb\",\"2SJR8\",\"index.6db8fd01.js\"]"));


var $800sp = parcelRequire("800sp");

var $ilwiq = parcelRequire("ilwiq");

var $ilwiq = parcelRequire("ilwiq");
const $164afa34e4b04624$var$_changeEvent = {
    type: 'change'
};
const $164afa34e4b04624$var$_startEvent = {
    type: 'start'
};
const $164afa34e4b04624$var$_endEvent = {
    type: 'end'
};
const $164afa34e4b04624$var$_EPS = 0.000001;
const $164afa34e4b04624$var$_STATE = {
    NONE: -1,
    ROTATE: 0,
    ZOOM: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_ZOOM_PAN: 4
};
const $164afa34e4b04624$var$_v2 = new (0, $ilwiq.Vector2)();
const $164afa34e4b04624$var$_mouseChange = new (0, $ilwiq.Vector2)();
const $164afa34e4b04624$var$_objectUp = new (0, $ilwiq.Vector3)();
const $164afa34e4b04624$var$_pan = new (0, $ilwiq.Vector3)();
const $164afa34e4b04624$var$_axis = new (0, $ilwiq.Vector3)();
const $164afa34e4b04624$var$_quaternion = new (0, $ilwiq.Quaternion)();
const $164afa34e4b04624$var$_eyeDirection = new (0, $ilwiq.Vector3)();
const $164afa34e4b04624$var$_objectUpDirection = new (0, $ilwiq.Vector3)();
const $164afa34e4b04624$var$_objectSidewaysDirection = new (0, $ilwiq.Vector3)();
const $164afa34e4b04624$var$_moveDirection = new (0, $ilwiq.Vector3)();
class $164afa34e4b04624$export$18b7f869be764a91 extends (0, $ilwiq.Controls) {
    constructor(object, domElement = null){
        super(object, domElement);
        // API
        this.enabled = true;
        this.screen = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        };
        this.rotateSpeed = 1.0;
        this.zoomSpeed = 1.2;
        this.panSpeed = 0.3;
        this.noRotate = false;
        this.noZoom = false;
        this.noPan = false;
        this.staticMoving = false;
        this.dynamicDampingFactor = 0.2;
        this.minDistance = 0;
        this.maxDistance = Infinity;
        this.minZoom = 0;
        this.maxZoom = Infinity;
        this.keys = [
            'KeyA' /*A*/ ,
            'KeyS' /*S*/ ,
            'KeyD' /*D*/ 
        ];
        this.mouseButtons = {
            LEFT: (0, $ilwiq.MOUSE).ROTATE,
            MIDDLE: (0, $ilwiq.MOUSE).DOLLY,
            RIGHT: (0, $ilwiq.MOUSE).PAN
        };
        this.state = $164afa34e4b04624$var$_STATE.NONE;
        this.keyState = $164afa34e4b04624$var$_STATE.NONE;
        this.target = new (0, $ilwiq.Vector3)();
        // internals
        this._lastPosition = new (0, $ilwiq.Vector3)();
        this._lastZoom = 1;
        this._touchZoomDistanceStart = 0;
        this._touchZoomDistanceEnd = 0;
        this._lastAngle = 0;
        this._eye = new (0, $ilwiq.Vector3)();
        this._movePrev = new (0, $ilwiq.Vector2)();
        this._moveCurr = new (0, $ilwiq.Vector2)();
        this._lastAxis = new (0, $ilwiq.Vector3)();
        this._zoomStart = new (0, $ilwiq.Vector2)();
        this._zoomEnd = new (0, $ilwiq.Vector2)();
        this._panStart = new (0, $ilwiq.Vector2)();
        this._panEnd = new (0, $ilwiq.Vector2)();
        this._pointers = [];
        this._pointerPositions = {};
        // event listeners
        this._onPointerMove = $164afa34e4b04624$var$onPointerMove.bind(this);
        this._onPointerDown = $164afa34e4b04624$var$onPointerDown.bind(this);
        this._onPointerUp = $164afa34e4b04624$var$onPointerUp.bind(this);
        this._onPointerCancel = $164afa34e4b04624$var$onPointerCancel.bind(this);
        this._onContextMenu = $164afa34e4b04624$var$onContextMenu.bind(this);
        this._onMouseWheel = $164afa34e4b04624$var$onMouseWheel.bind(this);
        this._onKeyDown = $164afa34e4b04624$var$onKeyDown.bind(this);
        this._onKeyUp = $164afa34e4b04624$var$onKeyUp.bind(this);
        this._onTouchStart = $164afa34e4b04624$var$onTouchStart.bind(this);
        this._onTouchMove = $164afa34e4b04624$var$onTouchMove.bind(this);
        this._onTouchEnd = $164afa34e4b04624$var$onTouchEnd.bind(this);
        this._onMouseDown = $164afa34e4b04624$var$onMouseDown.bind(this);
        this._onMouseMove = $164afa34e4b04624$var$onMouseMove.bind(this);
        this._onMouseUp = $164afa34e4b04624$var$onMouseUp.bind(this);
        // for reset
        this._target0 = this.target.clone();
        this._position0 = this.object.position.clone();
        this._up0 = this.object.up.clone();
        this._zoom0 = this.object.zoom;
        if (domElement !== null) {
            this.connect();
            this.handleResize();
        }
        // force an update at start
        this.update();
    }
    connect() {
        window.addEventListener('keydown', this._onKeyDown);
        window.addEventListener('keyup', this._onKeyUp);
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointercancel', this._onPointerCancel);
        this.domElement.addEventListener('wheel', this._onMouseWheel, {
            passive: false
        });
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = 'none'; // disable touch scroll
    }
    disconnect() {
        window.removeEventListener('keydown', this._onKeyDown);
        window.removeEventListener('keyup', this._onKeyUp);
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerup', this._onPointerUp);
        this.domElement.removeEventListener('pointercancel', this._onPointerCancel);
        this.domElement.removeEventListener('wheel', this._onMouseWheel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.domElement.style.touchAction = 'auto'; // disable touch scroll
    }
    dispose() {
        this.disconnect();
    }
    handleResize() {
        const box = this.domElement.getBoundingClientRect();
        // adjustments come from similar code in the jquery offset() function
        const d = this.domElement.ownerDocument.documentElement;
        this.screen.left = box.left + window.pageXOffset - d.clientLeft;
        this.screen.top = box.top + window.pageYOffset - d.clientTop;
        this.screen.width = box.width;
        this.screen.height = box.height;
    }
    update() {
        this._eye.subVectors(this.object.position, this.target);
        if (!this.noRotate) this._rotateCamera();
        if (!this.noZoom) this._zoomCamera();
        if (!this.noPan) this._panCamera();
        this.object.position.addVectors(this.target, this._eye);
        if (this.object.isPerspectiveCamera) {
            this._checkDistances();
            this.object.lookAt(this.target);
            if (this._lastPosition.distanceToSquared(this.object.position) > $164afa34e4b04624$var$_EPS) {
                this.dispatchEvent($164afa34e4b04624$var$_changeEvent);
                this._lastPosition.copy(this.object.position);
            }
        } else if (this.object.isOrthographicCamera) {
            this.object.lookAt(this.target);
            if (this._lastPosition.distanceToSquared(this.object.position) > $164afa34e4b04624$var$_EPS || this._lastZoom !== this.object.zoom) {
                this.dispatchEvent($164afa34e4b04624$var$_changeEvent);
                this._lastPosition.copy(this.object.position);
                this._lastZoom = this.object.zoom;
            }
        } else console.warn('THREE.TrackballControls: Unsupported camera type.');
    }
    reset() {
        this.state = $164afa34e4b04624$var$_STATE.NONE;
        this.keyState = $164afa34e4b04624$var$_STATE.NONE;
        this.target.copy(this._target0);
        this.object.position.copy(this._position0);
        this.object.up.copy(this._up0);
        this.object.zoom = this._zoom0;
        this.object.updateProjectionMatrix();
        this._eye.subVectors(this.object.position, this.target);
        this.object.lookAt(this.target);
        this.dispatchEvent($164afa34e4b04624$var$_changeEvent);
        this._lastPosition.copy(this.object.position);
        this._lastZoom = this.object.zoom;
    }
    _panCamera() {
        $164afa34e4b04624$var$_mouseChange.copy(this._panEnd).sub(this._panStart);
        if ($164afa34e4b04624$var$_mouseChange.lengthSq()) {
            if (this.object.isOrthographicCamera) {
                const scale_x = (this.object.right - this.object.left) / this.object.zoom / this.domElement.clientWidth;
                const scale_y = (this.object.top - this.object.bottom) / this.object.zoom / this.domElement.clientWidth;
                $164afa34e4b04624$var$_mouseChange.x *= scale_x;
                $164afa34e4b04624$var$_mouseChange.y *= scale_y;
            }
            $164afa34e4b04624$var$_mouseChange.multiplyScalar(this._eye.length() * this.panSpeed);
            $164afa34e4b04624$var$_pan.copy(this._eye).cross(this.object.up).setLength($164afa34e4b04624$var$_mouseChange.x);
            $164afa34e4b04624$var$_pan.add($164afa34e4b04624$var$_objectUp.copy(this.object.up).setLength($164afa34e4b04624$var$_mouseChange.y));
            this.object.position.add($164afa34e4b04624$var$_pan);
            this.target.add($164afa34e4b04624$var$_pan);
            if (this.staticMoving) this._panStart.copy(this._panEnd);
            else this._panStart.add($164afa34e4b04624$var$_mouseChange.subVectors(this._panEnd, this._panStart).multiplyScalar(this.dynamicDampingFactor));
        }
    }
    _rotateCamera() {
        $164afa34e4b04624$var$_moveDirection.set(this._moveCurr.x - this._movePrev.x, this._moveCurr.y - this._movePrev.y, 0);
        let angle = $164afa34e4b04624$var$_moveDirection.length();
        if (angle) {
            this._eye.copy(this.object.position).sub(this.target);
            $164afa34e4b04624$var$_eyeDirection.copy(this._eye).normalize();
            $164afa34e4b04624$var$_objectUpDirection.copy(this.object.up).normalize();
            $164afa34e4b04624$var$_objectSidewaysDirection.crossVectors($164afa34e4b04624$var$_objectUpDirection, $164afa34e4b04624$var$_eyeDirection).normalize();
            $164afa34e4b04624$var$_objectUpDirection.setLength(this._moveCurr.y - this._movePrev.y);
            $164afa34e4b04624$var$_objectSidewaysDirection.setLength(this._moveCurr.x - this._movePrev.x);
            $164afa34e4b04624$var$_moveDirection.copy($164afa34e4b04624$var$_objectUpDirection.add($164afa34e4b04624$var$_objectSidewaysDirection));
            $164afa34e4b04624$var$_axis.crossVectors($164afa34e4b04624$var$_moveDirection, this._eye).normalize();
            angle *= this.rotateSpeed;
            $164afa34e4b04624$var$_quaternion.setFromAxisAngle($164afa34e4b04624$var$_axis, angle);
            this._eye.applyQuaternion($164afa34e4b04624$var$_quaternion);
            this.object.up.applyQuaternion($164afa34e4b04624$var$_quaternion);
            this._lastAxis.copy($164afa34e4b04624$var$_axis);
            this._lastAngle = angle;
        } else if (!this.staticMoving && this._lastAngle) {
            this._lastAngle *= Math.sqrt(1.0 - this.dynamicDampingFactor);
            this._eye.copy(this.object.position).sub(this.target);
            $164afa34e4b04624$var$_quaternion.setFromAxisAngle(this._lastAxis, this._lastAngle);
            this._eye.applyQuaternion($164afa34e4b04624$var$_quaternion);
            this.object.up.applyQuaternion($164afa34e4b04624$var$_quaternion);
        }
        this._movePrev.copy(this._moveCurr);
    }
    _zoomCamera() {
        let factor;
        if (this.state === $164afa34e4b04624$var$_STATE.TOUCH_ZOOM_PAN) {
            factor = this._touchZoomDistanceStart / this._touchZoomDistanceEnd;
            this._touchZoomDistanceStart = this._touchZoomDistanceEnd;
            if (this.object.isPerspectiveCamera) this._eye.multiplyScalar(factor);
            else if (this.object.isOrthographicCamera) {
                this.object.zoom = (0, $ilwiq.MathUtils).clamp(this.object.zoom / factor, this.minZoom, this.maxZoom);
                if (this._lastZoom !== this.object.zoom) this.object.updateProjectionMatrix();
            } else console.warn('THREE.TrackballControls: Unsupported camera type');
        } else {
            factor = 1.0 + (this._zoomEnd.y - this._zoomStart.y) * this.zoomSpeed;
            if (factor !== 1.0 && factor > 0.0) {
                if (this.object.isPerspectiveCamera) this._eye.multiplyScalar(factor);
                else if (this.object.isOrthographicCamera) {
                    this.object.zoom = (0, $ilwiq.MathUtils).clamp(this.object.zoom / factor, this.minZoom, this.maxZoom);
                    if (this._lastZoom !== this.object.zoom) this.object.updateProjectionMatrix();
                } else console.warn('THREE.TrackballControls: Unsupported camera type');
            }
            if (this.staticMoving) this._zoomStart.copy(this._zoomEnd);
            else this._zoomStart.y += (this._zoomEnd.y - this._zoomStart.y) * this.dynamicDampingFactor;
        }
    }
    _getMouseOnScreen(pageX, pageY) {
        $164afa34e4b04624$var$_v2.set((pageX - this.screen.left) / this.screen.width, (pageY - this.screen.top) / this.screen.height);
        return $164afa34e4b04624$var$_v2;
    }
    _getMouseOnCircle(pageX, pageY) {
        $164afa34e4b04624$var$_v2.set((pageX - this.screen.width * 0.5 - this.screen.left) / (this.screen.width * 0.5), (this.screen.height + 2 * (this.screen.top - pageY)) / this.screen.width // screen.width intentional
        );
        return $164afa34e4b04624$var$_v2;
    }
    _addPointer(event) {
        this._pointers.push(event);
    }
    _removePointer(event) {
        delete this._pointerPositions[event.pointerId];
        for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i].pointerId == event.pointerId) {
            this._pointers.splice(i, 1);
            return;
        }
    }
    _trackPointer(event) {
        let position = this._pointerPositions[event.pointerId];
        if (position === undefined) {
            position = new (0, $ilwiq.Vector2)();
            this._pointerPositions[event.pointerId] = position;
        }
        position.set(event.pageX, event.pageY);
    }
    _getSecondPointerPosition(event) {
        const pointer = event.pointerId === this._pointers[0].pointerId ? this._pointers[1] : this._pointers[0];
        return this._pointerPositions[pointer.pointerId];
    }
    _checkDistances() {
        if (!this.noZoom || !this.noPan) {
            if (this._eye.lengthSq() > this.maxDistance * this.maxDistance) {
                this.object.position.addVectors(this.target, this._eye.setLength(this.maxDistance));
                this._zoomStart.copy(this._zoomEnd);
            }
            if (this._eye.lengthSq() < this.minDistance * this.minDistance) {
                this.object.position.addVectors(this.target, this._eye.setLength(this.minDistance));
                this._zoomStart.copy(this._zoomEnd);
            }
        }
    }
}
function $164afa34e4b04624$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this._pointers.length === 0) {
        this.domElement.setPointerCapture(event.pointerId);
        this.domElement.addEventListener('pointermove', this._onPointerMove);
        this.domElement.addEventListener('pointerup', this._onPointerUp);
    }
    //
    this._addPointer(event);
    if (event.pointerType === 'touch') this._onTouchStart(event);
    else this._onMouseDown(event);
}
function $164afa34e4b04624$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchMove(event);
    else this._onMouseMove(event);
}
function $164afa34e4b04624$var$onPointerUp(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchEnd(event);
    else this._onMouseUp();
    //
    this._removePointer(event);
    if (this._pointers.length === 0) {
        this.domElement.releasePointerCapture(event.pointerId);
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerup', this._onPointerUp);
    }
}
function $164afa34e4b04624$var$onPointerCancel(event) {
    this._removePointer(event);
}
function $164afa34e4b04624$var$onKeyUp() {
    if (this.enabled === false) return;
    this.keyState = $164afa34e4b04624$var$_STATE.NONE;
    window.addEventListener('keydown', this._onKeyDown);
}
function $164afa34e4b04624$var$onKeyDown(event) {
    if (this.enabled === false) return;
    window.removeEventListener('keydown', this._onKeyDown);
    if (this.keyState !== $164afa34e4b04624$var$_STATE.NONE) return;
    else if (event.code === this.keys[$164afa34e4b04624$var$_STATE.ROTATE] && !this.noRotate) this.keyState = $164afa34e4b04624$var$_STATE.ROTATE;
    else if (event.code === this.keys[$164afa34e4b04624$var$_STATE.ZOOM] && !this.noZoom) this.keyState = $164afa34e4b04624$var$_STATE.ZOOM;
    else if (event.code === this.keys[$164afa34e4b04624$var$_STATE.PAN] && !this.noPan) this.keyState = $164afa34e4b04624$var$_STATE.PAN;
}
function $164afa34e4b04624$var$onMouseDown(event) {
    if (this.state === $164afa34e4b04624$var$_STATE.NONE) switch(event.button){
        case this.mouseButtons.LEFT:
            this.state = $164afa34e4b04624$var$_STATE.ROTATE;
            break;
        case this.mouseButtons.MIDDLE:
            this.state = $164afa34e4b04624$var$_STATE.ZOOM;
            break;
        case this.mouseButtons.RIGHT:
            this.state = $164afa34e4b04624$var$_STATE.PAN;
            break;
    }
    const state = this.keyState !== $164afa34e4b04624$var$_STATE.NONE ? this.keyState : this.state;
    if (state === $164afa34e4b04624$var$_STATE.ROTATE && !this.noRotate) {
        this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
        this._movePrev.copy(this._moveCurr);
    } else if (state === $164afa34e4b04624$var$_STATE.ZOOM && !this.noZoom) {
        this._zoomStart.copy(this._getMouseOnScreen(event.pageX, event.pageY));
        this._zoomEnd.copy(this._zoomStart);
    } else if (state === $164afa34e4b04624$var$_STATE.PAN && !this.noPan) {
        this._panStart.copy(this._getMouseOnScreen(event.pageX, event.pageY));
        this._panEnd.copy(this._panStart);
    }
    this.dispatchEvent($164afa34e4b04624$var$_startEvent);
}
function $164afa34e4b04624$var$onMouseMove(event) {
    const state = this.keyState !== $164afa34e4b04624$var$_STATE.NONE ? this.keyState : this.state;
    if (state === $164afa34e4b04624$var$_STATE.ROTATE && !this.noRotate) {
        this._movePrev.copy(this._moveCurr);
        this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
    } else if (state === $164afa34e4b04624$var$_STATE.ZOOM && !this.noZoom) this._zoomEnd.copy(this._getMouseOnScreen(event.pageX, event.pageY));
    else if (state === $164afa34e4b04624$var$_STATE.PAN && !this.noPan) this._panEnd.copy(this._getMouseOnScreen(event.pageX, event.pageY));
}
function $164afa34e4b04624$var$onMouseUp() {
    this.state = $164afa34e4b04624$var$_STATE.NONE;
    this.dispatchEvent($164afa34e4b04624$var$_endEvent);
}
function $164afa34e4b04624$var$onMouseWheel(event) {
    if (this.enabled === false) return;
    if (this.noZoom === true) return;
    event.preventDefault();
    switch(event.deltaMode){
        case 2:
            // Zoom in pages
            this._zoomStart.y -= event.deltaY * 0.025;
            break;
        case 1:
            // Zoom in lines
            this._zoomStart.y -= event.deltaY * 0.01;
            break;
        default:
            // undefined, 0, assume pixels
            this._zoomStart.y -= event.deltaY * 0.00025;
            break;
    }
    this.dispatchEvent($164afa34e4b04624$var$_startEvent);
    this.dispatchEvent($164afa34e4b04624$var$_endEvent);
}
function $164afa34e4b04624$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $164afa34e4b04624$var$onTouchStart(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ROTATE;
            this._moveCurr.copy(this._getMouseOnCircle(this._pointers[0].pageX, this._pointers[0].pageY));
            this._movePrev.copy(this._moveCurr);
            break;
        default:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ZOOM_PAN;
            const dx = this._pointers[0].pageX - this._pointers[1].pageX;
            const dy = this._pointers[0].pageY - this._pointers[1].pageY;
            this._touchZoomDistanceEnd = this._touchZoomDistanceStart = Math.sqrt(dx * dx + dy * dy);
            const x = (this._pointers[0].pageX + this._pointers[1].pageX) / 2;
            const y = (this._pointers[0].pageY + this._pointers[1].pageY) / 2;
            this._panStart.copy(this._getMouseOnScreen(x, y));
            this._panEnd.copy(this._panStart);
            break;
    }
    this.dispatchEvent($164afa34e4b04624$var$_startEvent);
}
function $164afa34e4b04624$var$onTouchMove(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            this._movePrev.copy(this._moveCurr);
            this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
            break;
        default:
            const position = this._getSecondPointerPosition(event);
            const dx = event.pageX - position.x;
            const dy = event.pageY - position.y;
            this._touchZoomDistanceEnd = Math.sqrt(dx * dx + dy * dy);
            const x = (event.pageX + position.x) / 2;
            const y = (event.pageY + position.y) / 2;
            this._panEnd.copy(this._getMouseOnScreen(x, y));
            break;
    }
}
function $164afa34e4b04624$var$onTouchEnd(event) {
    switch(this._pointers.length){
        case 0:
            this.state = $164afa34e4b04624$var$_STATE.NONE;
            break;
        case 1:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ROTATE;
            this._moveCurr.copy(this._getMouseOnCircle(event.pageX, event.pageY));
            this._movePrev.copy(this._moveCurr);
            break;
        case 2:
            this.state = $164afa34e4b04624$var$_STATE.TOUCH_ZOOM_PAN;
            for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i].pointerId !== event.pointerId) {
                const position = this._pointerPositions[this._pointers[i].pointerId];
                this._moveCurr.copy(this._getMouseOnCircle(position.x, position.y));
                this._movePrev.copy(this._moveCurr);
                break;
            }
            break;
    }
    this.dispatchEvent($164afa34e4b04624$var$_endEvent);
}



var $eV4ey = parcelRequire("eV4ey");

var $i6UHQ = parcelRequire("i6UHQ");
var $a3d1fc10a411acaa$exports = {};
$a3d1fc10a411acaa$exports = new URL("math.33efa2c8.glb", import.meta.url).toString();


var $39bcc007843929ac$exports = {};
$39bcc007843929ac$exports = new URL("jennings_lo.b0822633.glb", import.meta.url).toString();


var $21b6eb858a64cb93$exports = {};
$21b6eb858a64cb93$exports = new URL("questionmark.638412b5.glb", import.meta.url).toString();


class $257ba3995936ae97$var$RayCast extends (0, $eV4ey.default) {
    static{
        this.properties = {
            cursorType: {
                type: String
            },
            mousePosX: {
                type: String
            },
            mousePosY: {
                type: String
            }
        };
    }
    constructor(){
        super(), this.infoVisible = 'hidden';
        this.setupScene = this.setupScene.bind(this);
        this.white = new $ilwiq.Color().setHex((0, $i6UHQ.default).white);
        this.dark_grey = new $ilwiq.Color().setHex((0, $i6UHQ.default).dark_grey);
        this.light_pink = new $ilwiq.Color().setHex((0, $i6UHQ.default).light_pink);
        this.bright_pink = new $ilwiq.Color().setHex((0, $i6UHQ.default).bright_pink);
        this.raycaster = new $ilwiq.Raycaster();
        this.mouse = new $ilwiq.Vector2();
        this.mousePosX = "0px";
        this.mousePosX = "0px";
        this.clickingActive = false;
        this.cursorType = "grab";
        this.infoVisible = 'hidden';
        this.canClick = false;
        this.beganTouching = false;
        this.geometries = {};
        this.meshes = {};
        this.addEventListener('mousedown', this.startClick);
        this.addEventListener('mouseup', this.clickLink);
        this.addEventListener('touchstart', this.touchStart);
        this.addEventListener("touchmove", this.touchMove);
        this.addEventListener("touchcancel", this.touchMove);
        this.addEventListener('touchend', this.touchEnd);
    }
    render() {
        return (0, $800sp.html)`
    <style>
      :host {
        cursor: ${this.cursorType};
      }
      .followMouse {
        top: ${this.mousePosY};
        left: ${this.mousePosX};
        font-size:50px;
        visibility: ${this.infoVisible};
        position:absolute;
        font-weight: 600;
        color: #ff284d;
        z-index: 10;
      }
      #crosshair {
        top: ${this.YCenter};
        left: ${this.XCenter};
        position: absolute;
        visibility: hidden;
        width: 0px;
        height: 0px;
        z-index: 100;
      }
      #upSpoke {
        background: white;
        height: 10px;
        width: 2px;
        transform: translateY(-3px);
      }
      #sideSpoke {
        background: white;
        height: 2px;
        width: 10px;
        transform: translate(-4px,-9px);
      }
      #container{
				top:0px;
				position: absolute;
			}
      @media (hover: none) {
        /* behaviour for touch browsers */
        #crosshair {
          visibility: visible;
        }
      }
    </style>
    <div id="container" ></div>
    <div id="infoText" class="followMouse" ></div>
    <div id="crosshair" >
      <div id="upSpoke"></div>
      <div id="sideSpoke"></div>
    </div>
    `;
    }
    startClick() {
        this.clickingActive = false;
        if (this.canClick == true) this.clickingActive = true;
    }
    clickLink() {
        if (this.clickingActive == true && this.canClick == true) window.location.href = this.link;
    }
    touchStart() {
        if (this.canClick) this.beganTouching = true;
    }
    touchMove() {
        this.beganTouching = false;
    }
    touchEnd() {
        if (this.canClick && this.beganTouching) window.location.href = this.link;
    }
    async firstUpdated() {
        // Give the browser a chance to paint
        await new Promise((r)=>setTimeout(r, 0));
        this.init();
        if (this.shadowRoot) {
            const debugElement = this.shadowRoot.getElementById("infoText");
            if (debugElement) this.debugWindow = debugElement;
        }
        this.setupLights();
        const modelUrls = [
            {
                key: 'que',
                url: (0, (/*@__PURE__*/$parcel$interopDefault($21b6eb858a64cb93$exports))),
                link: "statement",
                description: "statement"
            },
            {
                key: 'work',
                url: (0, (/*@__PURE__*/$parcel$interopDefault($39bcc007843929ac$exports))),
                link: "CV",
                description: "CV"
            },
            {
                key: 'math',
                url: (0, (/*@__PURE__*/$parcel$interopDefault($a3d1fc10a411acaa$exports))),
                link: "artwork",
                description: "artwork"
            }
        ];
        const files = await this.getFiles(modelUrls);
        this.modelInfo = modelUrls;
        this.addModels(files);
        this.setupScene();
        this.startAnimation();
    }
    setupLights() {
        this.camera = new $ilwiq.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.1, 100);
        this.camera.position.z = 20;
        this.scene.background = new $ilwiq.Color(this.light_pink);
        this.scene.add(new $ilwiq.AmbientLight(this.bright_pink));
        const light_one = new $ilwiq.SpotLight(this.white, 30000);
        light_one.position.set(0, 10, 100);
        this.scene.add(light_one);
        const light_two = new $ilwiq.HemisphereLight(this.white, this.bright_pink, 1);
        light_two.position.set(0, 1, 0);
        this.scene.add(light_two);
        const light_three = new $ilwiq.SpotLight(this.bright_pink, 30000);
        light_three.position.set(0, -10, -100);
        this.scene.add(light_three);
    }
    addModels(files) {
        const objsToDraw = 20;
        const material = new $ilwiq.MeshPhongMaterial({
            color: this.white,
            flatShading: true,
            shininess: 1
        });
        for(let i = 0; i < Object.keys(files).length; i++){
            var geometry = files[Object.keys(files)[i]];
            var mesh = new $ilwiq.InstancedMesh(geometry, material, objsToDraw);
            for(let j = 0; j < objsToDraw; j++){
                // Create a transformation matrix
                const matrix = new $ilwiq.Matrix4();
                // Random position
                const position = new $ilwiq.Vector3(Math.random() * 100 - 50, Math.random() * 100 - 50, Math.random() * 100 - 50);
                // Random rotation
                const rotation = new $ilwiq.Euler(Math.random() * 2 * Math.PI, Math.random() * 2 * Math.PI, Math.random() * 2 * Math.PI);
                // Apply position and rotation to the matrix
                matrix.compose(position, new $ilwiq.Quaternion().setFromEuler(rotation), new $ilwiq.Vector3(1, 1, 1) // scale (1, 1, 1) for no scaling
                );
                // Set the transformation matrix for the instance
                mesh.setMatrixAt(j, matrix);
                // Set color for the instance
                mesh.setColorAt(j, this.dark_grey);
            }
            this.meshes[Object.keys(files)[i]] = mesh;
            this.scene.add(mesh);
        }
    }
    setupScene() {
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.container?.appendChild(this.renderer.domElement);
        this.renderer.setAnimationLoop(this.startAnimation);
        this.controls = new (0, $164afa34e4b04624$export$18b7f869be764a91)(this.camera, this.renderer.domElement);
        this.controls.rotateSpeed = -1;
        window.addEventListener('resize', this.onWindowResize);
        document.addEventListener('mousemove', this.onMouseMove);
        var loadingDiv = this.parentElement?.querySelector('#loading');
        loadingDiv.style.visibility = 'hidden';
    }
    onWindowResize() {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }
    startAnimation() {
        this.controls.update();
        this.raycaster.setFromCamera(this.mouse, this.camera);
        this.renderer.setRenderTarget(null);
        this.cursorType = "cell";
        this.infoVisible = 'hidden';
        this.canClick = false;
        this.handleMouse();
        for(const key in this.meshes){
            const mesh = this.meshes[key];
            const intersection = this.raycaster.intersectObject(mesh);
            for(let i = 0; i < mesh.count; i++){
                mesh.setColorAt(i, this.dark_grey);
                mesh.instanceColor.needsUpdate = true;
            }
            if (intersection.length > 0) {
                this.infoVisible = 'visible';
                this.canClick = true;
                this.cursorType = "pointer";
                const modelInfoItem = this.modelInfo.find((item)=>item.key === key);
                if (modelInfoItem) {
                    this.link = this.parentElement?.querySelector("#" + modelInfoItem.link)?.href;
                    this.debugWindow.innerHTML = modelInfoItem.description;
                }
                const instanceId = intersection[0].instanceId;
                mesh.setColorAt(instanceId, this.light_pink);
                mesh.instanceColor.needsUpdate = true;
            }
        }
        this.renderer.render(this.scene, this.camera);
    }
    handleMouse() {
        this.mousePosX = this.mousePos.x + 15 + "px";
        this.mousePosY = this.mousePos.y + 15 + "px";
    }
}
window.customElements.define('ray-cast', $257ba3995936ae97$var$RayCast);


//# sourceMappingURL=index.81bdb204.js.map
